export let APP_VERSION;

export function setAppVersion(version: string): void {
  APP_VERSION = version;
  window['appVersion'] = APP_VERSION;
}
